// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AdminAddress } from './admin-address';
import { AdminAppointmentMethod } from './admin-appointment-method';
import { AdminBankrupt } from './admin-bankrupt';
import { AdminContact } from './admin-contact';
import { AdminCustomProperty } from './admin-custom-property';
import { AdminDatum } from './admin-datum';
import { AdminNumber } from './admin-number';
import { AdminSetting } from './admin-setting';
import { AdminStatus } from './admin-status';
import { AdminType } from './admin-type';
import { AdminTypeHistory } from './admin-type-history';
import { AdminWorkTeam } from './admin-work-team';
import { Appointment } from './appointment';
import { Asset } from './asset';
import { Bond } from './bond';
import { CounterpartyDatum } from './counterparty-datum';
import { Creditor } from './creditor';
import { CurrencyType } from './currency-type';
import { Dividend } from './dividend';
import { Document } from './document';
import { DocumentSetting } from './document-setting';
import { Employee } from './employee';
import { Liability } from './liability';
import { Lodgement } from './lodgement';
import { Meeting } from './meeting';
import { Practice } from './practice';
import { Shareholder } from './shareholder';
import { ShareholderClass } from './shareholder-class';
import { User } from './user';
import { UserAdminRole } from './user-admin-role';
import { iTask } from './i-task';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Admin extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  adminId!: number;
  adminAppointmentMethodId?: number;
  adminStatusId!: number;
  adminTypeId?: number;
  appointeeCostsAccountId?: number;
  appointeeFeesAccountId?: number;
  baseCurrencyTypeCurrencyTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  date1?: Date;
  date2?: Date;
  date3?: Date;
  documentFolder?: string;
  endDate?: Date;
  eraclaimAdminCreditorId?: number;
  flags?: number;
  hasHistory?: boolean;
  industryTypeId?: number;
  isLegacyImport?: boolean;
  isNotSecure!: boolean;
  isNotTaxReg!: boolean;
  name!: string;
  parentAdminId?: number;
  practiceId?: number;
  ratadate?: Date;
  ratadate1?: Date;
  ratastatus?: number;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  reportingUserId?: number;
  reportingUserId1?: number;
  shortName!: string;
  startDate?: Date;
  subTypeLookupId?: number;
  taxBasis!: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  usePracticeAddresses?: boolean;
  usePracticeNumbers?: boolean;
  webFlags?: number;
  workTeamAdminId?: number;
  accounts!: Account[];
  adminAddresses!: AdminAddress[];
  adminAppointmentMethod!: AdminAppointmentMethod;
  adminBankrupts!: AdminBankrupt[];
  adminContacts!: AdminContact[];
  adminCustomProperties!: AdminCustomProperty[];
  adminDatum!: AdminDatum;
  adminNumbers!: AdminNumber[];
  adminSettings!: AdminSetting[];
  adminStatus!: AdminStatus;
  adminType!: AdminType;
  adminTypeHistories!: AdminTypeHistory[];
  adminWorkTeamAdmins!: AdminWorkTeam[];
  adminWorkTeamWorkteamAdmins!: AdminWorkTeam[];
  appointments!: Appointment[];
  assets!: Asset[];
  baseCurrencyTypeCurrencyType!: CurrencyType;
  bonds!: Bond[];
  counterpartyData!: CounterpartyDatum[];
  creditors!: Creditor[];
  dividends!: Dividend[];
  documentSettings!: DocumentSetting[];
  documents!: Document[];
  employees!: Employee[];
  inverseParentAdmin!: Admin[];
  inverseWorkTeamAdmin!: Admin[];
  liabilities!: Liability[];
  lodgements!: Lodgement[];
  meetings!: Meeting[];
  parentAdmin!: Admin;
  practice!: Practice;
  reportingUser!: User;
  reportingUserId1Navigation!: User;
  shareholderClasses!: ShareholderClass[];
  shareholders!: Shareholder[];
  tasks!: iTask[];
  userAdminRoles!: UserAdminRole[];
  workTeamAdmin!: Admin;
}

